// Raise this value when the product API supports more variations per product.
export const MAX_PRODUCT_VARIATIONS = 1;
